import { mapState } from 'vuex';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'CoreTenantDrawerLinksEdit',
  components: {
    codemirror
  },
  props: {
    tenantTheme: {
      type: Object,
      required: true
    },
    // the indicies in order to get to the nested drawer-link-items
    hierarchyIndices: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      codeMirrorInstances: {},
      cmLineNumbers: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    linkItems() {
      if (this.hierarchyIndices.length === 0) {
        return this.tenantTheme.drawerLinks;
      }
      const indicies = this.hierarchyIndices.map(i => `[${i}].children`);
      return get(this.tenantTheme.drawerLinks, `${indicies.join('.')}`);
    },
    linkItemTypes() {
      return [this.hierarchyIndices.length === 0 ? {
        value: 'category',
        text: 'CATEGORY'
      } : null, {
        value: 'group',
        text: 'GROUP'
      }, {
        value: 'link',
        text: 'LINK'
      }].filter(lit => lit);
    },
    indentWidth() {
      return this.hierarchyIndices.length * 40;
    },
    routerPaths() {
      return this.$router.options.routes.map(r => r.path).concat(['GRAFANA_PLACEHOLDER', 'FIREFLY_PLACEHOLDER']);
    },
    cmOptions() {
      return {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      };
    }
  },
  methods: {
    togglePermissionEditor(index) {
      this.codeMirrorInstances[index] = !this.codeMirrorInstances[index];
      this.codeMirrorInstances = cloneDeep(this.codeMirrorInstances);
    },
    refreshForm(index) {
      setTimeout(() => {
        if (get(this.$refs, `codemirror_nested_${this.hierarchyIndices}_${index}.codemirror`)) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          this.$refs[`codemirror_nested_${this.hierarchyIndices}_${index}`].codemirror.refresh();
          this.$refs[`codemirror_nested_${this.hierarchyIndices}_${index}`].codemirror.focus();
        }
      }, 50);
    },
    onCmFocus(index) {
      this.refreshForm(index);
      this.cmLineNumbers = true;
    },
    finishedPermissionEditing(linkItem) {
      try {
        linkItem.permissions = JSON.parse(linkItem.permissionsJsonString);
        delete linkItem.permissionJsonError;
      } catch (e) {
        linkItem.permissionJsonError = e;
      }
      this.emitChange();
    },
    emitChange() {
      this.$emit('drawerlinks-changed');
    },
    changeDrawerLinksOrder(index, direction) {
      const newIndex = Math.min(this.linkItems.length - 1, Math.max(0, index + (direction === 'up' ? -1 : 1)));
      if (newIndex !== index) {
        const priorElement = this.linkItems[newIndex];
        this.linkItems[newIndex] = this.linkItems[index];
        this.linkItems[index] = priorElement;
      }
      this.emitChange();
    },
    changedLinkItemType(j) {
      if (this.linkItems[j].type === 'group') {
        if (!this.linkItems[j].children) {
          this.linkItems[j].children = [];
        }
      }
      this.emitChange();
    },
    addLinkItem() {
      this.linkItems.push({
        type: 'link',
        children: [],
        permissionsJsonString: '{}'
      });
      this.emitChange();
    },
    addGroupItem(j) {
      if (!this.linkItems[j].children) {
        this.linkItems[j].children = [];
      }
      this.linkItems[j].children.push({
        type: 'link',
        children: [],
        permissionsJsonString: '{}'
      });
      this.emitChange();
    },
    removeLinkItem(index) {
      pullAt(this.linkItems, [index]);
      this.emitChange();
    },
    removeLinkItems() {
      this.$emit('remove');
      this.emitChange();
    }
  }
};